module.exports = __webpack_public_path__ + "static/media/NABH-new.48509a00.png";